import { convertSecondsToHours } from './convert-seconds-to-hours';
export default convertSecondsToHours;
